module.exports = __webpack_public_path__ + "img/تصویری.8af7da5b.png";